import Vue from "vue";
import CryptoJS from 'crypto-js';
import { aesKey } from '@/config'
import Router from "@/router";
import Store from '@/store';
import {push_page_1, push_page_2} from "@/config/app.config";


export function cartesianProduct(arrays) {
    return arrays.reduce((acc, curr) => {
        return acc.flatMap(a =>
            curr.map(b => [...a, b])
        );
    }, [[]]);
}

/**
 * 格式化日期
 * @param {Date|string|number} date - 可以是Date对象、时间戳或日期字符串
 * @param {string} [format='YYYY-MM-DD HH:mm:ss'] - 格式字符串
 * @returns {string} 格式化后的日期字符串
 */
export function formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
    // 处理不同格式的日期输入
    let d;
    if (date instanceof Date) {
        d = date;
    } else if (typeof date === 'number') {
        d = new Date(date);
    } else if (typeof date === 'string') {
        // 处理字符串日期（简单处理，复杂情况可能需要更复杂的解析）
        d = new Date(date.replace(/-/g, '/'));
    } else {
        d = new Date();
    }

    // 补零函数
    const padZero = (num) => (num < 10 ? `0${num}` : num);

    // 格式化规则
    const formatMap = {
        YYYY: d.getFullYear(),
        MM: padZero(d.getMonth() + 1),
        DD: padZero(d.getDate()),
        HH: padZero(d.getHours()),
        mm: padZero(d.getMinutes()),
        ss: padZero(d.getSeconds()),
        SSS: padZero(d.getMilliseconds(), 3),
        YY: String(d.getFullYear()).slice(-2),
        M: d.getMonth() + 1,
        D: d.getDate(),
        H: d.getHours(),
        m: d.getMinutes(),
        s: d.getSeconds(),
    };

    // 替换格式化字符串中的占位符
    return format.replace(/(YYYY|YY|MM|M|DD|D|HH|H|mm|m|ss|s|SSS)/g, (match) => formatMap[match]);
}

/**
 * AES-ECB-128 加密
 * @param {string} data - 要加密的数据
 * @param {string} key - 加密密钥（16位字符）
 * @returns {string} 加密后的Base64字符串
 */
export function encryptAES(data) {
    if(!data){
        return data;
    }
    // 确保密钥是16位
    const keyHex = CryptoJS.enc.Utf8.parse(aesKey)

    // ECB模式不需要IV
    const encrypted = CryptoJS.AES.encrypt(data, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    })

    return encrypted.toString()
}

/**
 * AES-ECB-128 解密
 * @param {string} data - 要解密的Base64字符串
 * @param {string} key - 解密密钥（16位字符）
 * @returns {string} 解密后的原始数据
 */
export function decryptAES(data) {
    if(!data || typeof data !== 'string') {
       return data;
    }
    try {
        // 确保密钥是16位
        const keyHex = CryptoJS.enc.Utf8.parse(aesKey);

        // ECB模式不需要IV
        const decrypted = CryptoJS.AES.decrypt(
            data, 
            keyHex, 
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        );
        const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);
        
        if (!decryptedStr) {
            console.error('Decryption failed or returned empty result');
            return null;
        }
        return JSON.parse(decryptedStr);
    } catch (error) {
        console.error('Decryption error:', error);
        return null;
    }
}

export function jumpUrl(url){

    if(/wexin/i.test(url)){
        Vue.prototype.$baseLoading('即将跳转...')
        setTimeout(()=>window.location.href=url, 1500)
    }

    if(!/https?:\/\//i.test(url)){
        url=window.location.protocol+'//'+url
    }
    Vue.prototype.$baseLoading('即将跳转...')
    setTimeout(()=>window.location.href=url, 1500)
}

export function formatAmountChinese(value) {
    if (isNaN(value)) return '0';

    const num = Number(value);
    if (num === 0) return '0';

    const absNum = Math.abs(num);
    let unit = '';
    let scaledNum = num;

    if (absNum >= 100000000) {
        scaledNum = num / 100000000;
        unit = '亿';
    } else if (absNum >= 10000) {
        scaledNum = num / 10000;
        unit = '万';
    }

    // 格式化小数部分
    let decimalPlaces = 1;
    if (unit === '亿' && absNum < 1000000000) {
        decimalPlaces = 2;
    } else if (unit === '万' && absNum < 100000) {
        decimalPlaces = 2;
    }

    const fixedNum = scaledNum.toFixed(decimalPlaces);
    const formattedNum = fixedNum.endsWith('.00')
        ? fixedNum.slice(0, -3)
        : fixedNum.replace(/\.?0+$/, '');

    return formattedNum + unit;
}

export function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}



export function checkImgExists(url) {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
    });
}
